'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function stubObject() {
    return {};
}

exports.stubObject = stubObject;
